import _ from "underscore";
import join from "nllib/src/uri/join";
import get_url_prefix from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_url_prefix";
import LoginCore from "yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/login-core/1.0.1/index.vue";
import Footer from "@/page/distributor/component/basic-layout/1.0.1/component/footer/index.vue";
import Header from "@/page/supplier/component/header/1.0.3/index.vue";
import web_common_advert_showList from "@/lib/data-service/default/web_common_advert_showList";
export default {
  data() {
    return {
      tabNum: 0,
      swiperList: [],
    };
  },
  components: { LoginCore, Footer, Header },
  created() {},
  mounted() {
    const __this = this;

    this.getBanner();

    __this.$refs.aLoginCore.init({
      login_successfully_event_handler(data) {
        const token = data.token;
        const userType = data.userType;

        // 供应商
        if (_.contains([1, 2], userType)) {
          const url_prefix = get_url_prefix({
            appKey: `frontend-supplier`,
          });
          const url = join(
            url_prefix,
            `redirect/?redirectType=100&token=${token}`
          );
          window.location.href = url;
          return;
        }
        // 分销商
        if (_.contains([3, 4, 7], userType)) {
          const url_prefix = get_url_prefix({
            appKey: `frontend-distributor`,
          });

          const url = `${url_prefix}/redirect?redirectType=100&token=${token}`;

          console.log('url', url);
          // window.open(url, "_self");
          return;
        }

        // 平台
        if (_.contains([5], userType)) {
          const url_prefix = get_url_prefix({
            appKey: `frontend-platform`,
          });
          const url = join(
            url_prefix,
            `redirect/?redirectType=000&token=${token}`
          );
          window.location.href = url;
          return;
        }

        // 游客
        if (_.contains([6], userType)) {
          const url = `/general-user`;
          window.location.href = url;
          return;
        }
      },
    });
  },
  activated() {
    const __this = this;
    __this.form.userName = ``;
    __this.form.userPassword = ``;
  },
  deactivated() {},
  destroyed() {},
  watch: {},
  computed: {},
  filters: {},
  methods: {
    __btn_supplier_registration_click() {
      const __this = this;
      __this.$router.push({
        name: `supplier-registration`,
      });
    },

    __btn_distributor_registration_click() {
      const __this = this;
      __this.$router.push({
        name: `distributor-registration`,
      });
    },
    clickTab(num) {
      this.tabNum = num;
    },
    to_advantage() {
      const { href } = this.$router.resolve({
        name: "distributor-advantage",
      });

      window.open(href, "_blank");
    },
    // 获取banner
    getBanner() {
      let compare = function(obj1, obj2) {
        let val1 = obj1.advertSortNo;
        let val2 = obj2.advertSortNo;
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
      web_common_advert_showList({ advertPictureType: 1 }).then((res) => {
        this.swiperList = res.advertList;
      });
    },
  },
};
